import React from "react";
import { useNavigate } from "react-router-dom";
import { ShoppingBag, ChevronRight } from "lucide-react";
import { rupee } from "../../lib/format";
import { useCart } from "../../context/CartContext";

export function CartBar() {
  const { totals } = useCart();
  const navigate = useNavigate();
  if (totals.count === 0) return null;
  return (
    <button
      onClick={() => navigate("/cart")}
      data-testid="floating-cart-bar"
      className="fixed bottom-4 left-1/2 -translate-x-1/2 w-[92%] max-w-md z-40 gold-gradient text-slate-950 font-bold px-4 py-3 rounded-2xl shadow-2xl flex justify-between items-center transition-all duration-300 hover:scale-[1.02]">
      <div className="flex items-center gap-3">
        <div className="relative">
          <ShoppingBag size={22} />
          <span className="absolute -top-2 -right-2 bg-slate-950 text-amber-400 text-[10px] h-4 w-4 rounded-full flex items-center justify-center font-bold">
            {totals.count}
          </span>
        </div>
        <div className="text-left leading-tight">
          <div className="text-sm font-extrabold">{rupee(totals.payable)}</div>
          <div className="text-[10px] opacity-80">{totals.restaurants} restaurant{totals.restaurants > 1 ? "s" : ""}</div>
        </div>
      </div>
      <div className="flex items-center gap-1 text-sm">View Cart <ChevronRight size={18} /></div>
    </button>
  );
}
